<template>
    <div class="examineBox">
        <self-back :pageHeaderList="[{'name':'月度订单审核'}]"></self-back>
        <div class="containter" v-loading = 'loading'>
            <div class="topOperation clear">
                <span class="title">订单表</span>
            </div>
            <div class="listBox">
                <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" :max-height="tableMaxHeight" border>
                    <el-table-column prop="month_desc" label="表名称" align='center' width="200"></el-table-column>
                    <el-table-column prop="verifying" align='center' label="待审核订单数"></el-table-column>
                    <el-table-column prop="verify_success" align='center' label="审核通过订单数"></el-table-column>
                    <el-table-column prop="verify_fail" align='center' label="审核不通过订单数"></el-table-column>
                    <el-table-column align='center' label="操作">
                        <template slot-scope="scope">
                            <button class="detailButton" @click="goOrderDetail(scope.row)">订单详情</button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="paginationBox" style="height: 30px;">
                    <el-pagination
                        small
                        background
                        :current-page="page"
                        :page-size="page_size"
                        @current-change="handleCurrentChange"
                        layout="total, prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
 // 监测是否离开本页面
var hiddenProperty = 'hidden' in document ? 'hidden' :    
    'webkitHidden' in document ? 'webkitHidden' :    
    'mozHidden' in document ? 'mozHidden' :    
    null;
var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');

export default {
    data(){
        return{
            page:1,
            page_size:20,
            total:0,
            loading:false,
            tab:0,
            accountList:[]
        }
    },
    computed: {
        // 计算表格最大高度，确保分页控件可见
        tableMaxHeight() {
            return window.innerHeight - 253 > 400 ? window.innerHeight - 253 : 400;
        }
    },
    created(){
        this.orderMonthVerifys(1)
    },
    mounted(){
        document.addEventListener(visibilityChangeEvent, this.onVisibilityChange);
    },
    methods:{
        onVisibilityChange(){
            if (!document[hiddenProperty]) {
                this.orderMonthVerifys(this.page)
            }else{
                
            }
        },
        goOrderDetail(data){//去订单详情
            let routeData = this.$router.resolve({
                path: '/examineDetail/'+data.month,
            })
            this.$winopen(routeData.href)
        },
        handleCurrentChange(val){
            this.orderMonthVerifys(val)
        },
        orderMonthVerifys(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.orderMonthVerifys,{
               params:{
                   page: page,
                   pagesize: this.page_size,
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.accountList = res.rst.data;
                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
    },
    beforeDestroy(){
        document.removeEventListener(visibilityChangeEvent, this.onVisibilityChange);
    }
}
</script>
<style lang="scss" scoped>
.examineBox{
.containter{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: calc(100vh - 163px);
    .topOperation{
        padding: 16px;
        flex-shrink: 0;
        .title{
            font-size: 15px;
            color: #202652;
            line-height: 21px;
            font-weight: 500;
            display: inline-block;
            vertical-align: middle;
        }
        .selectBox{
            display: inline-block;
            vertical-align: middle;
            .selectItem{
                float: left;
                font-size: 13px;
                margin-left: 20px;
                cursor: pointer;
                .icon{
                    width: 13px;
                    height: 13px;
                    border-radius: 3px;
                    border: 1px solid #d2d2d2;
                    display: inline-block;
                    vertical-align: bottom;
                    margin-right: 3px;
                }
                &.active{
                    .icon{
                        border-color: #2662ff;
                        position: relative;
                        &::before{
                            content: "";
                            display: inline-block;
                            width: 7px;
                            height: 7px;
                            background: #2662ff;
                            border-radius: 1px;
                            position: absolute;
                            top: 2px;
                            left: 2px;
                        }
                    }
                }
            }
        }
    }
    .listBox{
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }
}
.table{
    width:calc(100% - 30px);
    margin:0 15px;
    flex: 1;
    min-height: 0;
}
.paginationBox{
    flex-shrink: 0;
    margin: 15px;
    padding-bottom: 0;
}
.detailButton{
    min-width: 60px;
    height: 26px;
    background: #5B7BFE;
    border-radius: 4px;
    color: #FFFFFF;
    font-size: 12px;
    border: none;
    padding: 0 6px;
}
}
</style>


// WEBPACK FOOTER //
// src/components/examine/index.vue